(ns guidebook.events
  (:require
   [graphql.core :as qu]
   [very.re-frame.core :as rf]
   ["moment" :as moment]
   [util.core :refer [un-edgify2]]
   ))

(defn submit-note [db]
  (assoc-in db [:guidebook :notes-modal :submitting?] true))

(rf/reg-event-db
  :guidebook/toggle-notes-modal
  (fn [db]
    (-> db
        (assoc-in [:guidebook :notes-modal :submitting?] false)
        (update-in [:guidebook :notes-modal :open?] not))))

(rf/reg-sub
  :guidebook/notes-modal
  (fn [db]
    (get-in db [:guidebook :notes-modal])))

(rf/reg-event-db
 :guidebook/set-page
 (fn [db [ctx]]
   (assoc-in db [:guidebook :page] ctx)))

(rf/reg-sub
 :guidebook/page
 (fn [db]
   (get-in db [:guidebook :page])))

(rf/reg-event-fx
  :guidebook/create-note
  [(rf/enrich submit-note)]
  (fn [cfx [data]]
    {:graphql {:gql (qu/create-guidebook-note {:input {:value (:value data)}})
               :success [:guidebook/toggle-notes-modal]}}))

(rf/reg-sub
 :guidebook/cover-page
 (fn [db]
   (select-keys (get-in db [:guidebook :data]) [:advisor :client :firm-logo])))

(rf/reg-sub
 :guidebook/footer
 (fn [db]
   (select-keys (get-in db [:guidebook :data]) [:client :firm-logo])))

(rf/reg-sub
 :guidebook/updated-at
 (fn [db]
   (get-in db [:guidebook :data :updated-at])))

(rf/reg-sub
 :guidebook/alignment
 (fn [db]
   (get-in db [:guidebook :data :alignment])))

(rf/reg-sub
 :guidebook/balance-sheet
 (fn [db]
   (get-in db [:guidebook :data :balance-sheet])))

(rf/reg-sub
 :guidebook/recommendation
 (fn [db]
   (get-in db [:guidebook :data :recommendation])))

(rf/reg-sub
 :guidebook/legacy-planning
 (fn [db]
   (get-in db [:guidebook :data :legacy-planning])))

(rf/reg-sub
 :guidebook/family-profile
 (fn [db]
   (get-in db [:guidebook :data :family-profile])))

(rf/reg-sub
 :guidebook/risk-profile
 (fn [db]
   (get-in db [:guidebook :data :client :risk-profile])))

(rf/reg-sub
 :guidebook/most-recent-risk-profile
 :<- [:guidebook/risk-profile]
 (fn [profs]
   (last profs)))

(rf/reg-sub
 :guidebook/cases
 (fn [db]
   (get-in db [:guidebook :data :cases])))

(rf/reg-sub
 :guidebook/strategies
 (fn [db]
   (get-in db [:guidebook :data :strategies])))

(defn priorities-last-modified [priorities]
  (last (sort (concat
                (map :last-modified-date priorities)
                (mapcat
                  (comp (partial map :last-modified-date) :goals) priorities)))))

(defn before-now? [goal]
  (assoc goal :before-now? (.isBefore (moment (:target-date goal)))))

(defn client-goals-before-now? [client]
  (update-in client [:priorities] (partial map #(update-in % [:goals] (partial map before-now?)))))

(rf/reg-sub
  :guidebook/priorities
  (fn [db]
    (let [priorities (get-in db [:guidebook :data :client :priorities])]
      {:priorities (sort-by :order priorities)
       :last-modified (priorities-last-modified priorities)})))

(rf/reg-sub
 :guidebook/key-consideration
 (fn [db]
   (get-in db [:guidebook :data :key-consideration])))

(rf/reg-sub
  :guidebook/value-relationships
  (fn [db]
    (get-in db [:guidebook :data :value-relationships])))

(rf/reg-sub
  :guidebook/performance
  (fn [db]
    (get-in db [:guidebook :data :accounts])))

(rf/reg-sub
  :guidebook/non-zero-accounts
  :<- [:guidebook/performance]
  (fn [perf]
    (sort-by :market-value > (remove #(zero? (:market-value %)) (get-in perf [:internal :accounts])))))

(rf/reg-sub
  :guidebook/total-account-allocation
  :<- [:guidebook/non-zero-accounts]
  (fn [accs]
    (reduce #(+ %1 (:percent %2)) 0 accs)))

(rf/reg-sub
  :guidebook/review
  (fn [db]
    (get-in db [:guidebook :data :review])))

(defn- loaded [cfx]
  {:dispatch [:loader/hide]})

(rf/reg-event-fx
 :guidebook/fetched
 [(rf/enrich-fx loaded)]
 (fn [cfx [{:keys [guidebook]}]]
   {:db (assoc-in (:db cfx)
                  [:guidebook :data]
                  (-> guidebook
                      (update :client client-goals-before-now?)
                      (update-in [:accounts :internal] (partial un-edgify2 :accounts))))}))

(rf/reg-event-fx
 :guidebook/fetched-with-errors
 [(rf/enrich-fx loaded)]
 (fn [cfx [{:keys [data errors]}]]
   {:db (assoc-in (:db cfx)
                  [:guidebook :data]
                  (-> (:guidebook data)
                      ;; @TODO how do we handle this? SOME of our data might
                      ;; come back, but we really have no idea what came back...
                      (update :client client-goals-before-now?)
                      (update-in [:accounts :internal] (partial un-edgify2 :accounts))
                      ))}))

(rf/reg-event-fx
  :guidebook/fetch
  (fn [cfx]
    {:dispatch [:loader/show]
     :graphql {:gql (qu/guidebook)
               :success [:guidebook/fetched]
               ;; even on error most of the data will come back just fine
               :error [:guidebook/fetched-with-errors]}}))
